'use strict';

import { addSelectedCompanyHandler, fnToastrFormError, getSelectedCompany } from "../jquery-functions-library";
import { element_exists } from "../functions";
import { fnDashV2AllTable } from "./admin/db-v2-all-table";
import { fnDashboardTaskTable } from "./dashboard-task-table";
import { fnDashboardProcedureTable } from "./dashboard-procedures-table";
import { fnDashboardVoucherTable } from "./dashboard-voucher-table";
import { fnDashboardPrimaryEmployee } from "./dashboard-primary-employee";


export var fnDashboard = function () {
    addSelectedCompanyHandler(setDashboard);

    if (element_exists('.client_user')) {
        setDashboard();

    } else if (element_exists('#selected_company')) {
        setDashboard();
    }
}

function setDashboard() {

    if ($('body').attr('data-company') !== undefined) {
        const selectedCompanyId = $('body').attr('data-company');
        $('#selected_company').val(selectedCompanyId);
    }

    if (getSelectedCompany() !== 'default' && ($('.client').hasClass('hidden') || $('.client').is(':visible'))) {
        $('.employee').hide();
        $.ajax({
            type: 'POST',
            url: '/setClientDashboard',
            success: function (response) {
                if (response.services.fixed_price > 0) {
                    $('.counter-1').html(response.services.fixed_price);
                } else {
                    $('.subtitle.price').text('N/A');
                }
                $('.counter-2').html(response.services.num_of_vouchers == 0 ? 'N/A' : response.services.num_of_vouchers);
                $('.counter-3').html(response.services.voucher_limit + ' DKK');
                $('.counter-4').html(response.services.has_salary);
                $('.counter-5').html(response.services.has_power_bi);
                $('.counter-6').html(response.services.report_deadline);
                $('.counter-7').html(response.services.vat_frequency);
                $('.counter-8').html(response.services.update_frequency);



                fnDashboardTaskTable();//TODO import at top?
                fnDashboardProcedureTable();
                fnDashboardVoucherTable();
                fnDashboardPrimaryEmployee();
                $('.client').removeClass('hidden');
            },
            error: fnToastrFormError,
        })

    }

    if (getSelectedCompany() === 'default') {

        $('.employee').show();
        fnDashV2AllTable();//TODO import?

        // $('#display-select-client').hide();

        $('.client').addClass('hidden');

        /*Avoid JS issues on other pages...*/
        if (element_exists('.employee.dashboard')) {
            $.fn.dataTable
                .tables({ visible: true, api: true })
                .columns.adjust()
                .fixedColumns().relayout();
        }
    }

    $('#datatable-db-v2-all tbody,#datatable-db-v2-all tbody').off('click', '.salary_output');
    $('#datatable-db-v2-all tbody,#datatable-db-v2-all tbody').on('click', '.salary_output', function (e) {
        e.stopPropagation();
        var company_id = $(this).attr('data-company');
        var reporting_period = $('#reporting-period').val();
        var companyGroupingVal = $('#company_grouping').val();

        var checked;
        if ($(this).is(':checked')) {
            checked = 1;
        } else {
            checked = 0
        }

        $.ajax({
            type: 'POST',
            url: '/toggleSalaryOutput',
            data: {
                company_id: company_id,
                checked: checked,
                reporting_period: reporting_period,
                company_grouping: companyGroupingVal
            },
            error: fnToastrFormError
        });
    });

    $(document).off('click', '.data_button');
    $(document).on('click', '.data_button', function (e) {
        e.preventDefault();

        var data_field_name = $(this).text();
        var data_field_id = $(this).attr('data-value');
        var data_field_group = $(this).attr('data-group');
        var data_field_approve = $(this).attr('data-approve');
        var reporting_period = $('#reporting-period').val();
        var company_id = $(this).attr('data-company');
        var class_color = $(this).attr('data-color');

        var parentBtn = $('[data-attachedUl=' + $(this).parent().attr('data-parent') + ']').find('.employee_field_button');
        /*var parentBtn = $(this).parent().parent().children('button');*/
        var parentBtnClass = parentBtn.attr('data-color');

        parentBtn.attr('data-color', class_color);
        parentBtn.removeClass(parentBtnClass);
        parentBtn.addClass(class_color);
        parentBtn.html(data_field_name + '<div class="ripple-container"></div>');

        var table = parentBtn.closest('.dataTable');

        console.log(data_field_group);

        var url = data_field_group !== 'vat_status' ? '/setDataField' : '/setVatStatus';

        $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });
        $.ajax({
            type: 'POST',
            url: url,
            data: {
                company_id: company_id,
                data_field_id: data_field_id,
                data_field_group: data_field_group,
                data_field_approve: data_field_approve,
                reporting_period: reporting_period,
            },
            success: function (response) {
            }
        })
    });
}
